export default __webpack_public_path__ + "static/google-play-es-4dbaf087003db30ede7d7efeb7d3c091.png";